import { Record } from 'immutable';
import { schema } from 'normalizr';

export const Radio = new Record({
  id: undefined,
  iccid: undefined,
  radio_type: undefined,
  ip_address: undefined,
  mac_address: undefined,
  port: undefined,
  data_plan: undefined,
  online: undefined,
  smartlink_unit: undefined,
  kore_status: undefined,
  kore_verifed_at: undefined,
  signal_strength_updated_at: null,
  last_known_signal_strength: null,
  comm_modes: 0,
});

export const radioSchema = new schema.Entity('radios');
